import mutationsTypes from '@/store/mutationTypes'

const state = {
  modal: {
    success: {
      isShow: false,
      message: ''
    },
    error: {
      isShow: false,
      message: ''
    }
  },
  pager: {
    orderHistory: {
      page: 1,
      pageCount: 1
    },
    orderLoading: {
      page: 1,
      pageCount: 1
    },
    salesHistory: {
      page: 1,
      pageCount: 1
    },
    salesShip: {
      page: 1,
      pageCount: 1
    },
    storageHistory: {
      page: 1,
      pageCount: 1
    },
    storageAdjustHistory: {
      page: 1,
      pageCount: 1
    }
  }
  // filter: {
  //   member: []
  // }
}
const mutations = {
  [mutationsTypes.UI_SET_SUCCESS_MODAL]: (state, payload) => {
    if (payload.message) {
      state.modal.success.message = payload.message
    }
    state.modal.success.isShow = payload.isShow
  },
  [mutationsTypes.UI_SET_ERROR_MODAL]: (state, payload) => {
    if (payload.error) {
      state.modal.error.message = payload.error
    }
    state.modal.error.isShow = payload.isShow
  },
  [mutationsTypes.UI_SET_PAGE]: (state, payload) => {
    const { key, index } = { ...payload }
    state.pager[key].page = index
  },
  [mutationsTypes.UI_SET_PAGE_COUNT]: (state, payload) => {
    const { key, length } = { ...payload }
    state.pager[key].pageCount = length
  }
  // [mutationsTypes.UI_SET_FILTER]: (state, payload) => {
  //   const { key, value } = { ...payload }
  //   state.filter[key] = value
  // }
}
const actions = {}
const getters = {
  successModal: (state) => {
    return state.modal.success
  },
  errorModal: (state) => {
    return state.modal.error
  },
  pageInfo: (state) => {
    return state.pager
  }
  // filterInfo: (state) => {
  //   return state.filter
  // }
}

const UIStore = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default UIStore
